import React from 'react'
import Onboarding from 'src/app/Onboarding/Onboarding'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { onboardingCardRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const OnboardingCardAppRoute: AppRoute = {
  id: AppLocation.OnboardingCard,
  routeProps: onboardingCardRouteProps,
  component: <Onboarding initialStep={3} />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default OnboardingCardAppRoute
